import Cookies from 'cookies-js'
import uuid from 'uuid'

import _context from '~/context'
import sharedCookieDomain from '~/lib/sharedCookieDomain'
import { TRACK, PAGE, IDENTIFY, LINKCLICK } from '../constants'
import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'

const TEN_SECONDS = 10

export const COOKIE_REFERRER_ID_NAME = 'ftref'

export default function fictiv(
    // todo change proper type when ApiClient migrated to typescript
    fictivApi: any,
    { product, version }: { product: string; version: string },
): AnalyticsHandlers {
    _context.setProductName(product)
    _context.setProductVersion(version)
    return {
        [IDENTIFY]({ userId, trueUserId }) {
            _context.setUserId(userId)
            _context.setTrueUserId(trueUserId)
        },
        [TRACK]({ event, properties }) {
            fictivApi.trackEvent(event, properties, _context.toJSON())
        },
        [PAGE]({ name, properties }) {
            const referrerId = Cookies.get(COOKIE_REFERRER_ID_NAME)

            Cookies.expire(COOKIE_REFERRER_ID_NAME, {
                domain: sharedCookieDomain(window.location),
            })
            fictivApi.trackEvent(
                'viewed_page',
                {
                    ...properties,
                    referrer_id: referrerId, // eslint-disable-line camelcase
                    name,
                },
                _context.toJSON(),
            )
        },
        [LINKCLICK]({ href, properties }) {
            const referrerId = uuid.v4()

            Cookies.set(COOKIE_REFERRER_ID_NAME, referrerId, {
                expires: TEN_SECONDS,
                domain: sharedCookieDomain(window.location),
            })
            fictivApi.trackEvent(
                'clicked_link',
                {
                    ...properties,
                    referrer_id: referrerId, // eslint-disable-line camelcase
                    href,
                },
                _context.toJSON(),
            )
        },
    }
}
